import { NgModule } from '@angular/core';

import { MediaExtractTypesPipe } from './media-extract-types.pipe';

@NgModule({
  declarations: [MediaExtractTypesPipe],
  exports: [MediaExtractTypesPipe]
})
export class NguixDashboardMediaExtractTypesPipeModule { }
